import React from "react";
import { NakiStoreFeaturedSectionTemplate } from "themes/administration/naki-store/pages";
import { NakiStoreFeaturedSectionViewStore } from "administration/naki-store/stores";
import { setCurrentView } from "mrb/core";
import { observer } from "mobx-react";

@setCurrentView(
    (rootStore, componentProps) => new NakiStoreFeaturedSectionViewStore(rootStore, componentProps),
    "nakiStoreFeaturedSectionViewStore"
)
@observer
class NakiStoreFeaturedSection extends React.Component {
    render() {
        return <NakiStoreFeaturedSectionTemplate {...this.props} />;
    }
}

export default NakiStoreFeaturedSection;
